import React, { useState, useEffect } from 'react';
import {
    makeStyles,
    withStyles,
    Typography,
    Slide as MUISlide,
    Dialog,
    IconButton,
    DialogContent,
    DialogActions,
    Button,
    DialogTitle,
    Divider,
    DialogContentText,
    Card,
    CardContent,
    FormHelperText,
    Collapse,
    Menu,
    MenuList,
    ClickAwayListener,
    Grow,
    Popper,
    Grid
} from "@material-ui/core";
import { addExpenseSelectionDialogCss } from './VehicleDialogCss';
import CloseIcon from '@material-ui/icons/Close';
import { FuelBookIcon, MaintenanceIcon, DriverExpensesIcon } from '../../../components/icons';
import AddFuelExpenseDialog from './AddFuelExpenseDialog';
import AddMaintainanceExpenseDialog from './AddMaintainanceExpenseDialog';
import { getTripDateFilterValues } from '../../../utils/utils';
import { singleTruck, PandL, Expenses } from '../../../store/actions/vehicleActionCreator';
import { connect } from "react-redux";
import * as logger from '../../../logger';
import AddDriverExpenseDialog from './AddDriverExpenseDialog';

const AddExpenseSelectionDialog = ({ open, onClose, vehicle, dispatchGetSingleTruck, dispatchGetPandL, dispatchGetTripExpenses }) => {

    const [dialogOpen, setDialogOpen] = useState(open);
    const [addFuelExpenseDialogOpen, setAddFuelExpenseDialogOpen] = useState(false);
    const [addMaintenanceExpenseDialogOpen, setAddMaintenanceExpenseDialogOpen] = useState(false);
    const [addDriverExpenseDialogOpen, setAddDriverExpenseDialogOpen] = useState(false);

    const classes = addExpenseSelectionDialogCss();

    let singleTruck = vehicle.singleTruck;

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const handleAddFuelExpenseClose = () => {
        setAddFuelExpenseDialogOpen(false);
        handleClose();
    }

    const handleAddMaintenanceExpenseClose = () => {
        setAddMaintenanceExpenseDialogOpen(false);
        onClose();
    }

    const handleAddDriverExpenseClose = () => {
        setAddDriverExpenseDialogOpen(false);
        onClose();
    }

    const handleAddExpenseClick = (type) => {
        if (type == "Fuel") {
            setAddFuelExpenseDialogOpen(true);
        } else if (type == "Maintenance") {
            setAddMaintenanceExpenseDialogOpen(true);
        } else if (type == "Driver") {
            setAddDriverExpenseDialogOpen(true);
        }
    }

    const handleExpenseConfirm = () => {

        let vehicleIdValue = singleTruck.id;

        var dateFilterValueUtil = getTripDateFilterValues();

        var startDateRange = dateFilterValueUtil["ALL_MONTHS"].startDateRange;

        var PandLdata = {
            vehicleId: vehicleIdValue,
            startDateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            }
        };

        var expenseData = {
            vehicleId: vehicleIdValue,
            startDateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            },
            expenseParentType: []
        };

        let defaultDateFilterValue = "ALL_MONTHS";
        let defaultTripBookFilterValue = "All Trips & Expenses";

        dispatchGetSingleTruck(vehicleIdValue,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Single Vehicle Component Dweb", "Get Single Truck Data Successfull ");
                    dispatchGetPandL(PandLdata, defaultDateFilterValue,
                        (data) => {
                            if (data && data.status && data.status.code == 200) {
                                logger.log("Single Vehicle Component Dweb", "Get P and L report Successfull");
                                dispatchGetTripExpenses(expenseData, defaultTripBookFilterValue,
                                    (data) => {
                                        if (data && data.status && data.status.code == 200) {
                                            logger.log("Single Vehicle Component Dweb", "Get Trip Expenses report Successfull");
                                            handleClose();
                                        }
                                    },
                                    () => {
                                        logger.log("Single Vehicle Component Dweb", "Get Trip Expenses report Failed");
                                    },
                                )
                            }
                        },
                        () => {
                            logger.log("Single Vehicle Component Dweb", "Get P and L report Failed");
                        },
                    )
                }
            },
            () => {
                logger.log("Single Vehicle Component Dweb", "Get Single Truck Data Failed");
            }
        );

    }

    return (
        <>
            <Dialog fullWidth={true}
                maxWidth='xs'
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-driver-dialog-title" open={dialogOpen} classes={{ paper: classes.paper1 }}>
                <DialogTitle className={classes.dialogTitleV1}>
                    <div className={classes.divV1}>Add Expenses</div>
                    <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent className={classes.dialogContentV1}>
                    <Grid
                        container
                        direction="row"
                        justify="space-between"
                        alignItems="center"
                    >
                        <Grid item className={classes.gridItemFuel} onClick={() => handleAddExpenseClick("Fuel")}>
                            <FuelBookIcon className={classes.fuelBookIcon} />
                            <div>Fuel</div>
                            <div>Expense</div>
                        </Grid>
                        <Grid item className={classes.gridItemMaintenance} onClick={() => handleAddExpenseClick("Maintenance")}>
                            <MaintenanceIcon className={classes.maintenanceIcon} />
                            <div>Maintenance</div>
                            <div>Expense</div>
                        </Grid>
                        <Grid item className={classes.gridItemDriver} onClick={() => handleAddExpenseClick("Driver")}>
                            <DriverExpensesIcon className={classes.driverIcon} />
                            <div>Driver/Other</div>
                            <div>Expense</div>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>

            {addFuelExpenseDialogOpen && <AddFuelExpenseDialog open={addFuelExpenseDialogOpen} onClose={handleAddFuelExpenseClose} onConfirm={handleExpenseConfirm} />}
            {addMaintenanceExpenseDialogOpen && <AddMaintainanceExpenseDialog open={addMaintenanceExpenseDialogOpen} onClose={handleAddMaintenanceExpenseClose} onConfirm={handleExpenseConfirm} />}
            {addDriverExpenseDialogOpen && <AddDriverExpenseDialog open={addDriverExpenseDialogOpen} onClose={handleAddDriverExpenseClose} onConfirm={handleExpenseConfirm} />}
        </>
    )
}

const mapStateToProps = (state) => ({ vehicle: state.vehicle });
const mapDispatchToProps = (dispatch) => ({
    dispatchGetSingleTruck: (truckId, onSuccess, onFailure) => dispatch(singleTruck(truckId, onSuccess, onFailure)),
    dispatchGetPandL: (data, defaultDateFilterValue, onSuccess, onFailure) => dispatch(PandL(data, defaultDateFilterValue, onSuccess, onFailure)),
    dispatchGetTripExpenses: (data, defaultTripBookFilterValue, onSuccess, onFailure) => dispatch(Expenses(data, defaultTripBookFilterValue, onSuccess, onFailure)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AddExpenseSelectionDialog);